<template>
  <el-dialog
      :width="screenWidth<=976?'85%':'964px'"
      append-to-body
      :show-close="false"
      :visible.sync="dialogFormVisible"
      :close-on-press-escape="false"
      :close-on-click-modal="false">
    <div class="content">
      <div class="header">
        <div class="header-top">
          <i class="el-icon-arrow-left" @click="closeDialog"></i>
          <!-- 选择付款方式-->
          <div class="header-title">{{$t('home.selectthepayment')}}</div>
        </div>
        <div class="header-desc">
          <img :src="`${$g.imgPrefix}/img/home/lock.svg`">
          <!-- AlongShare 不会存储您的银行卡信息。所有交易均由外部支付提供商进行保护、处理和授权。-->
          <div class="header-desc-text">{{$t('home.notstoreinfo')}}}</div>
        </div>
        <el-tabs v-model="tabActive">
          <el-tab-pane v-for="(tItem,tIndex) in tabList" :key="tIndex" :label="tItem.label" :name="tItem.value"></el-tab-pane>
        </el-tabs>
      </div>
      <div v-show="tabActive==='oncePay'" class="body">
        <div class="content-box">
          <div class="content-box-item" v-for="(item,i) in payOptions" :key="i" @click="choosePayment(item,i)">
            <!-- 未勾选-->
            <div v-if="!item.check" class="circle"></div>
            <!-- 已勾选-->
            <div v-else class="check">
              <div class="check-right">
                <img class="w-100" :src="`${$g.imgPrefix}/img/home/right.svg`">
              </div>
            </div>
            <div class="card-item">
              <div class="card-name">{{item.name}}</div>
              <div class="card-img">
                <img :src="item.ext1">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <div class="check-more" @click="changeArrow">
        <!-- 详情-->
        <span>{{$t('home.details')}}</span>
        <img :class="arrowUp?'arrow-up':'arrow-up arrow-down'" :src="`${$g.imgPrefix}/img/home/upArrow.svg`">
      </div>
      <!-- 详情-->
      <div v-show="!arrowUp" class="detail">
        <!-- 付款方式:-->
        <ul class="detail-item">
          <li class="detail-item-label">{{$t('footer.paymentmethod')}}</li>
          <li class="detail-item-value">{{ filterObj(tabList,'value',tabActive).label }}</li>
        </ul>

        <!--小计-->
        <ul class="detail-item">
          <li class="detail-item-label">{{$t('home.subtotal')}}</li>
          <li class="detail-item-value">$ {{ subTotal }}</li>
        </ul>

        <!-- 促销码&优惠券-->
        <ul class="detail-item">
          <li class="detail-item-label">{{$t('home.promotioncodescoupons')}}</li>
          <li class="detail-item-value">-$ {{ preferentialPrice }}</li>
        </ul>

        <!-- 付款费用-->
        <ul class="detail-item">
          <li class="detail-item-label">{{$t('home.paymentfee')}}</li>
          <li class="detail-item-value">+$ 0.00 (0.0%)</li>
        </ul>
      </div>

      <!-- 合计  小计+促销码&优惠劵-->
      <div class="total-box">
        <div class="total-box-title">{{$t('home.total')}}</div>
        <div class="total-box-amount">${{ total }}</div>
      </div>

      <div v-if="pageName==='shareAI'" class="couponY">
        <div class="couponY-top">
          <!-- 选择折扣（选择一项）-->
          <div class="content-title mb-0">{{$t('home.selectdiscount')}}</div>
        </div>
        <el-form :model="form1" ref="dataFormRef">
          <!-- 折扣码-->
          <el-form-item class="couponY-code">
            <el-input v-model.trim="form1.discountcode" @input="changeDiscountCode" :placeholder="$t('home.discountcode')"/>
            <!-- 使用-->
            <el-button size="small" type="primary" :disabled="!form1.discountcode" @click="useDiscountcode">{{ $t("home.use") }}</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="dialog-footer-btn">
        <!-- 取消-->
        <el-button @click="cancel">{{$t('friends.cancel')}}</el-button>
        <el-button type="primary" @click="goPay">{{ $t("home.buynow") }}</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import {
  getUserInfo,
  isEmpty,
  formatObj,
  filterObj,
  MessageError,
  startLoading
} from "@/util/util"
import {
  calprice,
  payssion,
  paytypeall,
  stripe
} from "@/request/requests";
export default {
  name: "goPay",
  props:{
    //页面路由名称：默认首页,也可能来自订阅页面购买
    pageName:{
      type:String,
      default:()=>{
        return 'home'
      }
    },
    //使用促销码是否已生效 true/false
    discountCodeFlag:{
      type:Boolean,
      default:()=>{
        return false
      }
    },
    form1Obj:{
      type:Object,
      default:()=>{
        return {
          goodsid: "",
          skuid: "",
          num: "",
          buytype: "",
          paycode: "",
          discountcode: "",
        }
      }
    },
    formObj:{
      type:Object,
      default:()=>{
        return{
          id: "", // 序号
          userid: "", // 用户id
          workorderno: "", // 工单号
          ticketid: "", // 车票id
          typeid: "", // 类型id
          content: "", // 工单内容
          status: "", // 状态
          reply: "", // 处理回复
          orderId: ""
        }
      }
    },
    goodsname:String
  },
  watch:{
    form1Obj:{
      handler(newVal){
        if(newVal){
          this.form1 = newVal;
        }
      },
      immediate:true,
      deep:true
    },
    formObj:{
      handler(newVal){
        if(newVal){
          this.form = newVal;
        }
      },
      immediate:true,
      deep:true
    },
    discountCodeFlag:{
      handler(newVal){
        console.log('watch',newVal)
        this.dataDiscountCodeFlag = newVal;
      },
      immediate:true
    }
  },
  data() {
    return {
      dialogFormVisible:false,
      tabActive:'oncePay',
      screenWidth:null,
      arrowUp:true,
      tabList:[
        {
          //一次性支付
          value:'oncePay',
          label: this.$t('home.alumpsum')
        }
      ],
      priceDataForm:{
        price:0,
        month:'',
        giftstimes:0,
        //原价
        originalprice:''
      },
      priceDataFormTemp:{},
      form1:{
        goodsid: "",
        skuid: "",
        num: "",
        buytype: "",
        paycode: "",
        discountcode: "",
      },
      form:{
        id: "", // 序号
        userid: "", // 用户id
        workorderno: "", // 工单号
        ticketid: "", // 车票id
        typeid: "", // 类型id
        content: "", // 工单内容
        status: "", // 状态
        reply: "", // 处理回复
        orderId: ""
      },
      cardList:[
        {
          check:true,
          name:'KaKaoPay',
          src:`${this.$g.imgPrefix}/img/home/pay.webp`
        },
        {
          check:false,
          name:'KaKaoPay',
          src:`${this.$g.imgPrefix}/img/home/pay.webp`
        },
        {
          check:false,
          name:'KaKaoPay',
          src:`${this.$g.imgPrefix}/img/home/pay.webp`
        }
      ],
      //小计
      subTotal:'0.00',
      //优惠券&折扣码
      preferentialPrice:'0.00',
      //总合计
      total:'0.00',
      payParams:{},
      userinfo:{},
      payOptions:[],
      paramsObj:{},
      submitPreventDouble:false,
      dataDiscountCodeFlag:false
    }
  },
  methods: {
    isEmpty,
    formatObj,
    filterObj,
    init(priceObj){
      console.log(priceObj);
      this.priceDataForm = priceObj;
      this.priceDataFormTemp = this.formatObj(priceObj);
      this.paytypeallInfo();
      this.arrowUp = true;
      this.dialogFormVisible = true;
      //计算小计
      this.calcSubTotal();
      //计算优惠劵&折扣码 优惠金额
      this.calcPreferentialPrice();
      //计算总合计
      this.calcTotal();
    },
    /**
     * 计算小计
     */
    calcSubTotal(){
      this.subTotal = '0.00';
      console.log(this.dataDiscountCodeFlag)
      if(this.dataDiscountCodeFlag){
        //使用促销码已生效  小计是原价
        this.subTotal = parseFloat(this.priceDataForm.originalprice).toFixed(2);
      }else{
        //使用促销码未生效
        this.subTotal = parseFloat(this.priceDataForm.price).toFixed(2);
      }
    },
    /**
     * 计算优惠劵&折扣码 优惠金额
     */
    calcPreferentialPrice(){
      this.preferentialPrice = '0.00';
      if(!this.isEmpty(this.priceDataForm.originalprice)){
        //原价 > 现价
        if(parseFloat(this.priceDataForm.originalprice) > parseFloat(this.priceDataForm.price)){
          this.preferentialPrice = parseFloat(this.priceDataForm.originalprice-this.priceDataForm.price).toFixed(2);
        }
      }
    },
    /**
     * 计算总合计
     */
    calcTotal(){
      this.total = '0.00';
      this.total = parseFloat(this.subTotal-this.preferentialPrice).toFixed(2);
    },

    changeDiscountCode(val){
      if(isEmpty(val)){
        //恢复初始价格
        //现价
        this.$set(this.priceDataForm,'price',this.priceDataFormTemp.price);
        //原价
        this.$set(this.priceDataForm,'originalprice','');
        this.dataDiscountCodeFlag = false;
        //计算小计
        this.calcSubTotal();
        //计算优惠劵&折扣码 优惠金额
        this.calcPreferentialPrice();
        //计算总合计
        this.calcTotal();
      }
    },
    async useDiscountcode(){
      let code = this.form1.discountcode;
      if ("" == code || null == code) {
        MessageError(this.$t("home.discountcodenotempty"));
        return;
      }

      if(!this.checkIsLogin()){
        return
      }

      let data = {
        goodsid: this.form1.goodsid,
        skuid: this.form1.skuid,
        num: this.form1.num * 1,
        discountcode: this.form1.discountcode,
        userid: this.userinfo.id,
      }
      let loading = startLoading();
      let res = await calprice(data);
      if (res.status == "200") {
        //使用折扣码已生效
        if (!isEmpty(res.data)
            && 0 != res.data
            && parseFloat(res.data) < parseFloat(this.priceDataForm.price)) {
          //原价
          this.$set(this.priceDataForm,'originalprice',this.priceDataForm.price);
          //现价
          this.$set(this.priceDataForm,'price',res.data);
          this.dataDiscountCodeFlag = true;
          //计算小计
          this.calcSubTotal();
          //计算优惠劵&折扣码 优惠金额
          this.calcPreferentialPrice();
          //计算总合计
          this.calcTotal();
        }
        loading.close();
      } else {
        MessageError(res.msg);
        loading.close();
      }
    },
    checkIsLogin(){
      if (!this.userinfo){
        this.dialogFormVisible = false;
        if (this.screenWidth > 576.98) {
          this.$router.push({name:'login'});
        } else {
          this.$router.push({name:'phonelogin'});
        }
        return false;
      }else{
        return true;
      }
    },
    changeArrow(){
      this.arrowUp = !this.arrowUp;
    },
    choosePayment(item,index){
      this.$set(this.form1,'paycode',item.code);
      this.payOptions.forEach((pItem,pIndex)=>{
        this.$set(pItem,'check',false);
        if(index===pIndex){
          this.$set(pItem,'check',true);
        }
      })
    },
    async paytypeallInfo() {
      let res = await paytypeall();
      if (res.status == "200") {
        this.payOptions = res.data;
        if(!this.isEmpty(this.payOptions)){
          this.$set(this.form1,'paycode',this.payOptions[0].code);
          this.payOptions.forEach((item,i)=>{
            this.$set(item,'check',false);
            if(i==0){
              this.$set(item,'check',true);
            }
          })
        }
      } else {
        MessageError(res.msg);
      }
    },
    calcWidth() {
      this.screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      this.$forceUpdate();
    },
    closeDialog(){
      this.dialogFormVisible = false;
    },
    goBack(){
      this.closeDialog();
    },
    cancel(){
      this.dialogFormVisible = false;
      this.$emit('closeToBuy')
    },
    goPay(){
      this.paramsObj = {};
      let form1 = formatObj(this.form1);
      let params = {
        pmid: "alipay_cn",
        amount: 0.07,
        description: this.goodsname + this.priceDataForm.price + this.priceDataForm.skuname,
        ...form1,
        userid: this.userinfo.id,
        sessionid: sessionStorage.getItem("session_id")
      }

      //订阅页面购买
      if(this.pageName=='subscribe'){
        this.paramsObj = {
          ...params,
          orderId: this.form.orderId,
          ticketid: this.form.ticketid
        }
      }else{
        //首页购买
        this.paramsObj = params;
      }

      if(this.submitPreventDouble){
        return
      }
      this.submitPreventDouble = true;
      if ("smailwallet" == this.form1.paycode||this.form1.paycode.includes('smailwallet')) {
        
				console.log("TCL: goPay -> ", )
        this.tostripe(this.paramsObj)
      } else if("only" == this.form1.paycode||this.form1.paycode.includes('only')){
        //显示Billing Details弹窗
        this.$emit("openBillDetails");
        this.submitPreventDouble = false;
      }else{
        this.toPayssion(this.paramsObj)
      }
    },
    async tostripe(params){
      //   let session_id = sessionStorage.getItem("session_id");
      //   const params = {
      //   pmid: "alipay_cn",
      //   amount: 0.07,
      //   description: this.goodsname + this.price + this.month,
      //   goodsid: this.form1.goodsid,
      //   skuid: this.form1.skuid,
      //   num: this.form1.num,
      //   buytype: this.form1.buytype,
      //   paycode: this.form1.paycode,
      //   // paycode: "payssion_test",
      //   discountcode: this.form1.discountcode,

      //   firstname: this.form2.firstname,
      //   lastname: this.form2.lastname,
      //   company: this.form2.company,
      //   country: this.form2.country,
      //   state: this.form2.state,
      //   city: this.form2.city,
      //   address: this.form2.address,
      //   postalcode: this.form2.postalcode,
      //   phone: this.form2.phone,
      //   email: this.form2.email,

      //   name: this.form3.name,
      //   cardnumber: this.form3.cardnumber,
      //   cvv: this.form3.cvv,
      //   date: this.form3.date,
      //   issave: this.form3.issave == true ? 1 : 0,
      //   userid: this.userinfo.id,
      //   sessionid: session_id,
      // };
			console.log("TCL: tostripe -> ", params)
      const res = await stripe(params);
      let loading = startLoading();
      if (res.data.code == "10000") {
        const url =res.data.web_url+"&return_url="+encodeURIComponent("https://www.alongshare.com/")
        window.open(url, "_self");
      } else {
        loading.close();
        MessageError(res.msg);
      }
    },
    async toPayssion(params) {
      let loading = startLoading();
      const res = await payssion(params);
      if (res.status == 200) {
        window.open(res.data.redirect_url, "_self");
      } else {
        loading.close();
        MessageError(res.msg);
        this.submitPreventDouble = false;
        this.dataDiscountCodeFlag = false;
      }
    },
  },
  mounted(){
    let userInfo = getUserInfo();
    if (userInfo) {
      this.userinfo = JSON.parse(userInfo);
    }
    this.$nextTick(() => {
      this.calcWidth();
      window.addEventListener("resize", this.calcWidth);
    })
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.calcWidth);
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
  &__header, &__body{
    padding:0;
  }
  .body{
    height: calc(100vh - 640px);
    overflow-y: auto;
  }
  .header {
    box-shadow: 0 4px 24px #00000014;
    &-top{
      padding:20px;
      display: flex;
      align-items: center;
    }
    &-desc{
      padding:0 20px;
      display:flex;
      flex-wrap: wrap;
      align-items: center;
      margin-bottom:10px;
      img{
        width:20px;
        margin-right:7px;
      }
      &-text{
        flex:1;
        color: #a3a0a0;
      }
    }

    &-title{
      font-size: 20px;
      font-weight: 700;
      color:#000;
    }
    .el-icon-arrow-left:before {
      color:#000;
      font-size:20px;
      margin-right:10px;
      font-weight: bold;
      cursor: pointer;
    }

  }

  .el-tabs{
    padding:0 20px;
    &__nav-wrap::after{
      background-color: transparent;
    }
    &__header{
      margin-bottom:0;
    }
    &__item.is-active {
      color: #000;
    }
    &__item{
      font-size:16px;
      height:43px;
      line-height: 43px;
    }
    .is-top{
     min-width:80px;
    }
  }

  .content{
    &-title{
      font-size: 14px;
      font-weight: 700;
      color:#000;
      margin-bottom:20px;
    }

    .month{
      display:flex;
      align-items: center;
    }
    .item{
      position: relative;
      border-radius: 8px;
      background-color: #fbf8f8;
      padding: 12px 16px;
      cursor: pointer;
      display:inline;

      &:not(:last-child){
        margin-right:16px;
      }
    }
    .active{
      color: #ef534f;
      border: 2px solid #ef534f;
    }
    .sold-out{
      background: #f0eded;
      border-radius: 0 8px;
      color: #a3a2a2;
      display: inline;
      font-size: 10px;
      padding: 0 4px;
      position: absolute;
      right: -2px;
      top: -2px;
    }
    .couponN{
      text-decoration: underline;
      font-weight: bold;
      color:#000;
      cursor: pointer;
    }


    &-box{
      padding:24px 24px 8px 24px;
      display:flex;
      justify-content: space-between;
      flex-wrap: wrap;

      &-item{
        border:1px solid #e5e1e1;
        border-radius: 8px;
        cursor: pointer;
        margin-bottom: 16px;
        padding: 6px 20px 16px 10px;
        width:calc(100% / 2 - 6px);
        display:flex;
        .circle{
          border-radius: 50%;
          width:20px;
          height:20px;
          border:1px solid #a3a0a0;
        }
        .card-item{
          margin-left:15px;
          flex:1;
        }
        .card-name{
          color: #333232 !important;
          font-weight: 700;
          margin-bottom:10px;
        }
        .card-img{
          display:flex;
          flex-wrap: wrap;
          border-radius: 4px;
          img{
            width:40px;
            object-fit: contain;
            &:not(:last-child){
              margin:0 8px 8px 0;
            }

          }
        }
        .check{
          position:relative;
          background-color: #5BC17F;
          border-radius: 50%;
          width:20px;
          height:20px;
          &-right{
            position:absolute;
            top:50%;
            left:50%;
            transform: translate(-50%,-50%);
            width:22px;
          }
        }

      }
    }
    .active-pay{
      border:1px solid #84F0AA!important;
    }

  }

  &__footer{
    position: relative;
    padding:20px!important;
    border-top: 1px solid #f5f2f2;
    box-shadow: 0 -12px 16px #0000000f;
  }

}
.dialog-footer{
  .check-more{
    background: #000;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    color: #fff;
    font-size: 16px;
    cursor: pointer;
    display:flex;
    justify-content: center;
    padding: 0 24px;
    position: absolute;
    top: 12px;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
  }
  .arrow-up {
    width:21px;
    margin-left:5px;
    transition: all 0.3s ease-in;
  }
  .arrow-down{
    transform: rotate(180deg);
    transition: all 0.3s ease-out;
  }
  .detail{
    margin:15px 0 24px 0;
    &-item{
      display:flex;
      justify-content: space-between;
      font-size:16px;
      &:not(:last-child){
        margin-bottom:16px;
      }

      &-label{
        color: #a3a0a0;
      }
      &-value{
        color:rgba(0, 0, 0, 0.87)
      }

    }
  }

  .total-box{
    display:flex;
    justify-content: space-between;
    align-items: center;
    margin:14px 0;
    &-title{
      color:#000;
      font-size:20px;
      font-weight: bold;
    }
    &-amount{
      color: #ef534f;
      font-size: 32px;
      font-weight: bold;
    }
  }

  .couponY{
    margin-bottom:24px;
    &-top{
      cursor: pointer;
      margin-bottom:7px;
      display:flex;
      align-items: center;
      justify-content: space-between;
    }

    &-coupon{
      position:relative;
      .desc{
        position: absolute;
        top: 50%;
        right: 39px;
        transform: translateY(-50%);
        z-index: 99;
      }
    }

   ::v-deep &-code{
      margin-bottom:0;
      .el-form-item__content{
        display:flex;
        align-items: center;
      }
      .el-input{
        flex:1;
      }
      .el-button{
        width:12%;
        margin-left:10px;
        padding:15px 8px;
        white-space: pre-line;
      }
    }
  }

  &-btn{
    .el-button{
      font-size:14px;
      padding: 20px 40px !important;
      border-radius: 34px !important;
      width:calc(100% / 2 - 10px);
      @media(max-width:575.98px){
        padding:10px 40px!important;
      }
    }
  }

}

</style>